<template>
  <nuxt-link
    class="notification-panel__notification-link"
    :to="route"
    @click="markAsReadAndHandleClick"
  >
    <div class="notification-panel__notification-content-title">
      <i18n-t keypath="rowChecklistCompletedNotification.title" tag="span">
        <template #contact>
          <strong>{{
            notification.data.contact_name ||
            $t('rowChecklistCompletedNotification.someone')
          }}</strong>
        </template>
        <template #title>
          <strong>{{ notification.data.checklist_title }}</strong>
        </template>
      </i18n-t>
    </div>
    <div class="notification-panel__notification-content-desc">
      {{
        $t('rowChecklistCompletedNotification.items', {
          done: notification.data.items_done,
          total: notification.data.items_total,
        })
      }}
    </div>
  </nuxt-link>
</template>

<script>
import notificationContent from '@baserow/modules/core/mixins/notificationContent'

export default {
  name: 'RowChecklistCompletedNotification',
  mixins: [notificationContent],
  emits: ['close-panel'],
  methods: {
    handleClick() {
      this.$emit('close-panel')
    },
  },
}
</script>
